import crossfilter from 'crossfilter2'

export const xf = crossfilter()
